import React from 'react'
import { isMobile } from 'react-device-detect'
import DocumentMeta from 'react-document-meta'
import HompeageTop from './HompeageTop'
import BlackquoteHomepage from './BlackquoteHomepage'
import ContactHp from './ContactHp'
import CustomHeading from './CustomHeading'
import ActivitiesHomPage from './ActivitiesHomPage'
import EmptySpace from './EmptySpace'

import Video from './Video'
import {
  szczecinUpper,
  pilaUpper,
  pilaLower,
  szcecinLower
} from '../helpers/cityHelper';



const Home = ({selectedCity, setCity}) => {
  const storagSelectedCity = sessionStorage.getItem('selectedCity');

  if (selectedCity !== storagSelectedCity) {
    setCity(selectedCity);
  }

  const cityUpprer = selectedCity === 'szczecin' ? szczecinUpper : pilaUpper;
  const cityLower = selectedCity === 'szczecin' ? szcecinLower : pilaLower;

  const meta = {
    title: `Żłobek Rudolf - prywatny żłobek ${cityUpprer}`,
    description: `Prywatny żłobek Rudolf ${cityUpprer} zapewnia  
      wykwalifikowaną kadrę opiekuńczo pedagogiczną oraz opiekę pielęgniarską. 
      Żłobek zapewnia pełne wyżywienie w cenie czesnego. Godziny otwarcia miedzy 
      6.30 a 17 z pewnością pozwolą wszystkim rodzicom dopasować sobie plan 
      przyprowadzania oraz odbierania maluszków ze żłobka. Zajęcia dodatkowe 
      umożliwiające prawidłowy rozwój 
      dziecka takie jak rytmika, zajęcia plastyczne,
      umuzykalniające oraz językowe.`,
    meta: {
      name: {
        keywords: `zlobek rudolf, żłobek ${cityLower}, 
        prywatny żłobek ${cityLower}, zlobek ${cityLower},  
        niepubliczny zlobek ${cityLower}`,
      },
    },
  }
  return (
    <DocumentMeta {...meta}>
      <div className="wrapper home_page">
        {!isMobile && <Video />}

        <div className="container">
          {!isMobile && <HompeageTop />}
          <CustomHeading
            text="Zajęcia w naszym żłobku"
            className="homepage__heading"
          />
          <ActivitiesHomPage />
          <EmptySpace />
          <CustomHeading text="To dzieci są prawdziwymi obserwatorami tego świata" />
          <BlackquoteHomepage />
        </div>
        <ContactHp />
      </div>
    </DocumentMeta>
  )
}

export default Home
